<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)">
      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaMidias(empresaSelecionada)"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-1" style="border-radius: 10px; padding: 20px;">
          <!-- Toolbar -->
          <div class="midias-toolbar">
            <h2 class="textoUser" style="margin: 0;">MÍDIAS</h2>
            <div class="midias-toolbar-actions">
              <v-text-field
                v-model="tabela.busca"
                prepend-inner-icon="mdi-magnify"
                placeholder="Buscar mídias..."
                solo
                flat
                dense
                hide-details
                class="midias-toolbar-busca"
              ></v-text-field>
              <v-select
                v-model="filtroTipo"
                :items="opcoesFiltroTipo"
                item-text="text"
                item-value="value"
                label="Tipo"
                dense
                outlined
                hide-details
                class="midias-toolbar-filtro-tipo"
              ></v-select>
              <v-btn-toggle v-model="viewMode" mandatory>
                <v-btn small value="list">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
                <v-btn small value="grid">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
              <v-tooltip bottom v-if="(user.tipo == 'ADMIN' || (user.tipo == 'GERENTE' && user.franquia)) && empresaSelecionada == ''">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn text tile color="#2C2E83" disabled>
                      <v-icon left dark>mdi-cloud-upload</v-icon>Fazer Upload
                    </v-btn>
                  </span>
                </template>
                <span>Selecione uma empresa primeiro</span>
              </v-tooltip>
              <v-btn 
                v-else
                text 
                @click="dialogoUpload = true" 
                tile 
                color="#2C2E83"
              >
                <v-icon left dark>mdi-cloud-upload</v-icon>Fazer Upload
              </v-btn>
            </div>
          </div>

          <!-- Loading -->
          <div v-if="tabela.carregamento" style="text-align: center; padding: 60px;">
            <v-progress-circular indeterminate color="#2C2E83" size="64"></v-progress-circular>
            <p style="margin-top: 20px; color: #666;">Carregando mídias...</p>
          </div>

          <!-- Grid de Cards -->
          <div v-else-if="viewMode === 'grid' && !tabela.carregamento" class="media-grid">
            <div
              v-for="item in filteredItems"
              :key="item.id"
              class="media-card"
              @mouseenter="hoveredCard = item.id"
              @mouseleave="hoveredCard = null"
            >
              <!-- Thumbnail -->
              <div class="media-thumbnail" @click="openMedia(item)">
                <div v-if="item.tipo === 'IMAGEM'" class="thumbnail-image">
                  <img :src="getMediaUrl(item.url)" :alt="item.nome" @error="handleImageError" />
                  <div class="overlay" v-if="hoveredCard === item.id">
                    <v-icon color="white" size="48">mdi-eye</v-icon>
                  </div>
                </div>
                <div v-else-if="item.tipo === 'VÍDEO'" class="thumbnail-video">
                  <video :src="getMediaUrl(item.url)" preload="metadata" muted></video>
                  <div class="play-overlay">
                    <v-icon color="white" size="48">mdi-play-circle</v-icon>
                  </div>
                  <div class="overlay" v-if="hoveredCard === item.id">
                    <v-icon color="white" size="48">mdi-eye</v-icon>
                  </div>
                </div>
                <div v-else-if="item.tipo === 'PDF'" class="thumbnail-pdf">
                  <v-icon color="#EF5350" size="64">mdi-file-pdf</v-icon>
                  <div class="overlay" v-if="hoveredCard === item.id">
                    <v-icon color="white" size="48">mdi-eye</v-icon>
                  </div>
                </div>
                <div v-else class="thumbnail-other">
                  <v-icon color="#666" size="64">mdi-file</v-icon>
                  <div class="overlay" v-if="hoveredCard === item.id">
                    <v-icon color="white" size="48">mdi-eye</v-icon>
                  </div>
                </div>
              </div>

              <!-- Card Info -->
              <div class="media-info">
                <div class="media-name" :title="item.nome">{{ truncateName(item.nome) }}</div>
                <div class="media-meta">
                  <v-chip x-small :color="getTipoColor(item.tipo)" dark style="margin-right: 8px;">
                    {{ item.tipo }}
                  </v-chip>
                  <span class="media-size">{{ formatarTamanhoKb(item) }}</span>
                </div>
              </div>

              <!-- Actions Menu -->
              <v-menu offset-y :close-on-content-click="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="card-action-btn"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop
                    :style="{ opacity: hoveredCard === item.id ? 1 : 0.6 }"
                  >
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="openMedia(item)">
                    <v-list-item-icon>
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Visualizar</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="copiarTexto(item.url, item.id)">
                    <v-list-item-icon>
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Copiar URL</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="deleteItem(item)">
                    <v-list-item-icon>
                      <v-icon small color="red">mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title style="color: red;">Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <!-- Empty State -->
            <div v-if="filteredItems.length === 0" class="empty-state">
              <v-icon size="80" color="#ccc">mdi-folder-open-outline</v-icon>
              <h3 style="color: #666; margin-top: 20px;">Nenhuma mídia encontrada</h3>
            </div>
          </div>

          <!-- List View (Tabela) -->
          <v-data-table
            v-else
            :headers="tabela.cabecalho"
            :items="filteredItems"
            :search="tabela.busca"
            sort-by="created"
            :sort-desc="true"
            class="elevation-0"
            :loading="tabela.carregamento"
            loading-text="Buscando itens..."
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.tipo`]="{ item }">
              <v-chip x-small :color="getTipoColor(item.tipo)" dark>{{ item.tipo }}</v-chip>
            </template>
            <template v-slot:[`item.created`]="{ item }">
              <span v-if="item.created">{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:[`item.url`]="{ item }">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click="openMedia(item)">
                      <v-icon v-if="item.tipo === 'IMAGEM'" color="blue">mdi-image</v-icon>
                      <v-icon v-else-if="item.tipo === 'VÍDEO'" color="red">mdi-video</v-icon>
                      <v-icon v-else-if="item.tipo === 'PDF'" color="#EF5350">mdi-file-document</v-icon>
                      <v-icon v-else color="grey">mdi-file</v-icon>
                    </v-btn>
                  </template>
                <span>Visualizar {{ item.nome }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.tamanho`]="{ item }">
              {{ formatarTamanhoKb(item) }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="copiarTexto(item.url, item.id)" color="primary">{{ midiaAcabouDeCopiar(item) ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
                  </v-btn>
                </template>
                <span>Copiar URL</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-alert dark dense text outlined :value="true" color="warning" icon="info" style="margin: 10px">Nenhuma mídia para exibir</v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de Upload -->
      <v-dialog v-model="dialogoUpload" :persistent="uploadando" max-width="900px" scrollable>
        <v-card>
          <v-card-title style="padding: 20px 24px; border-bottom: 1px solid #e0e0e0;">
            <span style="font-size: 20px; font-weight: 600;">Upload de mídias</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="fecharDialogoUpload" :disabled="uploadando">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding: 40px;">
            <!-- Área de Upload -->
            <div style="max-width: 600px; margin: 0 auto;">
                <!-- Drag and Drop Area -->
                <div
                  class="upload-area"
                  :class="{ 'drag-over': isDragging }"
                  @drop="handleDrop"
                  @dragover.prevent="isDragging = true"
                  @dragleave="isDragging = false"
                  @click="triggerFileInput"
                >
                  <input
                    ref="fileInput"
                    type="file"
                    multiple
                    style="display: none;"
                    @change="onFileSelected"
                    accept="image/*,video/*,.pdf"
                  />
                  <div class="upload-content">
                    <v-icon size="64" color="#2C2E83" style="margin-bottom: 20px;">mdi-cloud-upload</v-icon>
                    <h3 style="font-size: 18px; font-weight: 600; margin-bottom: 10px;">Arraste e solte um ou mais arquivos</h3>
                    <p style="color: #666; margin-bottom: 20px;">ou</p>
                    <v-btn
                      color="#2C2E83"
                      dark
                      large
                      @click.stop="triggerFileInput"
                    >
                      Faça upload
                    </v-btn>
                  </div>
                </div>

                <!-- Fila de arquivos -->
                <div v-if="filaUpload.length > 0" style="margin-top: 24px;">
                  <p style="font-weight: 600; margin-bottom: 12px;">{{ filaUpload.length }} arquivo(s) na fila</p>
                  <div
                    v-for="entry in filaUpload"
                    :key="entry.uid"
                    class="upload-queue-row"
                  >
                    <div class="upload-queue-thumb">
                      <img v-if="entry.tipoArquivo === 'image' && entry.previewUrl" :src="entry.previewUrl" alt="" />
                      <video v-else-if="entry.tipoArquivo === 'video' && entry.previewUrl" :src="entry.previewUrl" muted preload="metadata"></video>
                      <v-icon v-else-if="entry.tipoArquivo === 'pdf'" color="#EF5350" size="40">mdi-file-pdf</v-icon>
                      <v-icon v-else color="#757575" size="40">mdi-file</v-icon>
                    </div>
                    <div class="upload-queue-fields">
                      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-bottom: 8px;">
                        <span style="font-weight: 500; word-break: break-all;">{{ entry.file.name }}</span>
                        <v-chip x-small :color="getTipoColor(entry.tipoMidia)" dark>{{ entry.tipoMidia }}</v-chip>
                      </div>
                      <v-text-field
                        v-model="entry.nomeMidia"
                        outlined
                        dense
                        hide-details
                        label="Nome (opcional)"
                        :placeholder="entry.file.name"
                        :disabled="uploadando"
                      ></v-text-field>
                    </div>
                    <v-btn icon small :disabled="uploadando" @click="removerDaFilaUpload(entry.uid)" aria-label="Remover da fila">
                      <v-icon small color="#999">mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div v-if="uploadando" style="margin-top: 24px;">
                  <v-progress-linear :value="uploadProgresso" color="#2C2E83" height="10" rounded></v-progress-linear>
                  <p style="margin: 10px 0 0 0; font-size: 13px; color: #666;">
                    Enviando {{ uploadArquivoAtual }} de {{ uploadArquivoTotal }}… {{ uploadProgresso }}%
                  </p>
                </div>
            </div>
          </v-card-text>
          <v-card-actions style="padding: 15px 24px; border-top: 1px solid #e0e0e0; justify-content: flex-end;">
            <v-btn text @click="fecharDialogoUpload" style="margin-right: 10px;" :disabled="uploadando">Cancelar</v-btn>
            <v-btn
              color="#2C2E83"
              style="color: white"
              @click="fazerUpload"
              :disabled="filaUpload.length === 0 || uploadando"
              :loading="uploadando"
            >
              <v-icon left v-if="!uploadando">mdi-upload</v-icon>
              {{ labelBotaoEnviarUpload }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <!-- Dialog de Visualização -->
    <v-dialog v-model="dialogoVisualizar" max-width="900px" content-class="media-preview-dialog">
      <v-card v-if="midiaVisualizada">
        <v-card-title class="preview-modal-header">
          <span class="preview-modal-title">{{ midiaVisualizada.nome }}</span>
          <v-spacer></v-spacer>
          <v-chip x-small :color="getTipoColor(midiaVisualizada.tipo)" dark class="mr-2">
            {{ midiaVisualizada.tipo }}
          </v-chip>
          <v-btn icon @click="fecharDialogoVisualizar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="preview-modal-body">
          <div v-if="midiaVisualizada.tipo === 'IMAGEM'" class="preview-container">
            <img
              :src="getMediaUrl(midiaVisualizada.url)"
              :alt="midiaVisualizada.nome"
              class="preview-image"
              @error="handlePreviewError"
            />
          </div>
          <div v-else-if="midiaVisualizada.tipo === 'VÍDEO'" class="preview-container">
            <video
              ref="previewVideo"
              :src="getMediaUrl(midiaVisualizada.url)"
              class="preview-video"
              controls
              autoplay
            ></video>
          </div>
          <div v-else-if="midiaVisualizada.tipo === 'PDF'" class="preview-container preview-pdf">
            <iframe :src="getMediaUrl(midiaVisualizada.url)" class="preview-iframe" title="Visualizar PDF"></iframe>
          </div>
          <div v-else class="preview-container preview-other">
            <v-icon size="80" color="#666">mdi-file</v-icon>
            <p style="margin-top: 16px; color: #666;">Visualização não disponível para este tipo de arquivo.</p>
            <v-btn text color="#2C2E83" class="mt-2" @click="abrirEmNovaAba(midiaVisualizada)">
              <v-icon left>mdi-open-in-new</v-icon>Abrir em nova aba
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="preview-modal-actions">
          <v-btn text color="#2C2E83" @click="copiarTexto(midiaVisualizada.url, midiaVisualizada.id)">
            <v-icon left small>mdi-content-copy</v-icon>Copiar URL
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialogoVisualizar">Fechar</v-btn>
          <v-btn
            v-if="midiaVisualizada.tipo !== 'OUTRO'"
            text
            color="#2C2E83"
            @click="abrirEmNovaAba(midiaVisualizada)"
          >
            <v-icon left small>mdi-open-in-new</v-icon>Nova aba
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmar exclusão -->
    <v-dialog v-model="dialogoExcluir" max-width="480px" :persistent="excluindo">
      <v-card v-if="midiaParaExcluir">
        <v-card-title style="padding-bottom: 8px;">
          <span style="font-size: 18px; font-weight: 600;">Excluir mídia?</span>
        </v-card-title>
        <v-card-text>
          <p style="margin: 0 0 12px 0; color: #666;">Esta ação não pode ser desfeita.</p>
          <p style="margin: 0; font-weight: 600;">{{ midiaParaExcluir.nome || midiaParaExcluir.url }}</p>
          <div style="margin-top: 12px; display: flex; align-items: center; flex-wrap: wrap; gap: 8px;">
            <v-chip x-small :color="getTipoColor(midiaParaExcluir.tipo)" dark>{{ midiaParaExcluir.tipo }}</v-chip>
            <span style="font-size: 13px; color: #666;">{{ formatarTamanhoKb(midiaParaExcluir) }}</span>
          </div>
        </v-card-text>
        <v-card-actions style="padding: 12px 16px;">
          <v-spacer></v-spacer>
          <v-btn text :disabled="excluindo" @click="fecharDialogoExcluir">Cancelar</v-btn>
          <v-btn color="#EF5350" dark depressed :loading="excluindo" @click="confirmarExclusao">
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbarCopiar"
      :timeout="3500"
      bottom
      :color="snackbarCopiarCor"
      content-class="midias-snackbar-copy"
    >
      {{ snackbarCopiarMsg }}
    </v-snackbar>

    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  
  export default {
    components: { Snackbar },
    data: () => ({
      empresaSelecionada: '',
      empresas: [],
      dialogoUpload: false,
      dialogoVisualizar: false,
      midiaVisualizada: null,
      dialogoExcluir: false,
      midiaParaExcluir: null,
      excluindo: false,
      filaUpload: [],
      uploadProgresso: 0,
      uploadArquivoAtual: 0,
      uploadArquivoTotal: 0,
      uploadando: false,
      isDragging: false,
      hoveredCard: null,
      midiaCopiadaId: null,
      snackbarCopiar: false,
      snackbarCopiarMsg: '',
      snackbarCopiarCor: 'success',
      viewMode: 'list',
      filtroTipo: '',
      opcoesFiltroTipo: [
        { text: 'Todos os tipos', value: '' },
        { text: 'Imagem', value: 'IMAGEM' },
        { text: 'Vídeo', value: 'VÍDEO' },
        { text: 'PDF', value: 'PDF' },
        { text: 'Outro', value: 'OUTRO' },
      ],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', value: 'nome' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Enviado em', value: 'created' },
          { text: 'Tamanho', value: 'tamanho' },
          { text: 'Visualizar', value: 'url' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
    }),

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj,
      }),
      filteredItems() {
        let items = [...this.tabela.conteudo]

        items.sort((a, b) => new Date(b.created) - new Date(a.created))

        if (this.filtroTipo) {
          items = items.filter(item => item.tipo === this.filtroTipo)
        }

        if (this.tabela.busca) {
          const search = this.tabela.busca.toLowerCase()
          items = items.filter(item => {
            const texto = `${item.nome || ''} ${item.tipo || ''}`.toLowerCase()
            return texto.includes(search)
          })
        }

        return items
      },
      labelBotaoEnviarUpload() {
        if (this.uploadando) return 'Enviando...'
        const n = this.filaUpload.length
        if (n <= 1) return 'Enviar'
        return `Enviar ${n} arquivos`
      },
    },

    watch: {
      dialogoUpload(val) {
        if (val == false) {
          setTimeout(() => {
            this.revogarPreviewsFila()
            this.filaUpload = []
            this.isDragging = false
            this.uploadProgresso = 0
            this.uploadArquivoAtual = 0
            this.uploadArquivoTotal = 0
          }, 300)
        }
      },
      dialogoVisualizar(val) {
        if (!val) {
          const video = this.$refs.previewVideo
          if (video) {
            video.pause()
            video.currentTime = 0
          }
          this.midiaVisualizada = null
        }
      },
      dialogoExcluir(val) {
        if (!val && !this.excluindo) {
          setTimeout(() => {
            this.midiaParaExcluir = null
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)) {
        this.carregaEmpresas()
      } else {
        this.carregaMidias(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        let filter

        if (this.user.tipo == 'GERENTE' && this.user.franquia) {
          filter = {
            where: {"franquia": this.user.franquia},
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }
        else {
          filter = {
            order: "nome ASC",
            fields: {"nome": true, "id": true}
          }
        }

        await axios.get(baseApiUrl + 'Empresas?filter=' + JSON.stringify(filter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaMidias(empresaId) {
        if (!empresaId) {
          this.tabela.conteudo = []
          return
        }
        
        this.tabela.carregamento = true
        this.tabela.conteudo = []

        await axios.get(baseApiUrl + 'Uploads?filter={"where":{"empresaId":"' + empresaId + '"},"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && Array.isArray(response.data)) {
            this.tabela.conteudo = response.data
          } else {
            this.tabela.conteudo = []
          }
          this.tabela.carregamento = false
        })
        .catch(() => {
          this.tabela.carregamento = false
          this.tabela.conteudo = []
        })
      },


      triggerFileInput() {
        this.$refs.fileInput.click()
      },

      handleDrop(e) {
        e.preventDefault()
        this.isDragging = false
        const files = e.dataTransfer.files
        if (files.length > 0) {
          this.adicionarArquivosAFila(Array.from(files))
        }
      },

      onFileSelected(event) {
        const raw = event.target.files ? Array.from(event.target.files) : []
        if (event.target) {
          event.target.value = ''
        }
        if (raw.length > 0) {
          this.adicionarArquivosAFila(raw)
        }
      },

      isArquivoMidiaAceito(file) {
        const t = (file.type || '').toLowerCase()
        const name = (file.name || '').toLowerCase()
        if (t.startsWith('image/')) return true
        if (t.startsWith('video/')) return true
        if (t === 'application/pdf' || name.endsWith('.pdf')) return true
        return false
      },

      detectarTipoArquivo(file) {
        const t = file.type || ''
        if (t.startsWith('image/')) {
          return { tipoMidia: 'IMAGEM', tipoArquivo: 'image' }
        }
        if (t.startsWith('video/')) {
          return { tipoMidia: 'VÍDEO', tipoArquivo: 'video' }
        }
        if (t === 'application/pdf' || (file.name || '').toLowerCase().endsWith('.pdf')) {
          return { tipoMidia: 'PDF', tipoArquivo: 'pdf' }
        }
        return { tipoMidia: 'OUTRO', tipoArquivo: 'other' }
      },

      adicionarArquivosAFila(fileList) {
        const novos = []
        let ignorados = 0
        for (const file of fileList) {
          if (!this.isArquivoMidiaAceito(file)) {
            ignorados++
            continue
          }
          const { tipoMidia, tipoArquivo } = this.detectarTipoArquivo(file)
          let previewUrl = null
          if (tipoArquivo === 'image' || tipoArquivo === 'video') {
            previewUrl = URL.createObjectURL(file)
          }
          novos.push({
            uid: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
            file,
            tipoMidia,
            tipoArquivo,
            nomeMidia: '',
            previewUrl,
          })
        }
        if (ignorados > 0 && novos.length === 0) {
          this.$refs.chamaSnackbar.snack('orange', 'Nenhum arquivo válido (use imagem, vídeo ou PDF).', 'ATENÇÃO')
          return
        }
        if (ignorados > 0) {
          this.$refs.chamaSnackbar.snack('orange', `${ignorados} arquivo(s) ignorados (tipo não permitido).`, 'ATENÇÃO')
        }
        this.filaUpload = [...this.filaUpload, ...novos]
      },

      removerDaFilaUpload(uid) {
        const entry = this.filaUpload.find(e => e.uid === uid)
        if (entry && entry.previewUrl) {
          URL.revokeObjectURL(entry.previewUrl)
        }
        this.filaUpload = this.filaUpload.filter(e => e.uid !== uid)
      },

      revogarPreviewsFila() {
        this.filaUpload.forEach((entry) => {
          if (entry.previewUrl) {
            URL.revokeObjectURL(entry.previewUrl)
          }
        })
      },

      async fazerUpload() {
        if (!this.filaUpload.length) {
          this.$refs.chamaSnackbar.snack('orange', 'Adicione pelo menos um arquivo.', 'ATENÇÃO')
          return
        }

        const empresaId = this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)
          ? this.empresaSelecionada
          : this.companyobj.id

        const vm = this
        const filaSnapshot = [...this.filaUpload]
        const total = filaSnapshot.length

        this.uploadando = true
        this.uploadProgresso = 0
        this.uploadArquivoAtual = 0
        this.uploadArquivoTotal = total

        let ok = 0
        let falhas = 0
        const uidsEnviados = []
        const falhouDetalhes = []

        for (let i = 0; i < filaSnapshot.length; i++) {
          const entry = filaSnapshot[i]
          this.uploadArquivoAtual = i + 1

          const atualizarProgresso = (loaded, totalBytes) => {
            if (!totalBytes) return
            const fracAtual = loaded / totalBytes
            const base = (i / total) * 100
            const contrib = (fracAtual / total) * 100
            this.uploadProgresso = Math.min(100, Math.round(base + contrib))
          }

          try {
            // Upload via multipart/streaming (FormData) — o navegador envia o arquivo
            // direto, sem carregar/converter em base64 na memoria (evita "Out of Memory").
            const dados = new FormData()
            dados.append('empresaId', empresaId)
            dados.append('tipo', entry.tipoMidia || '')
            dados.append('nome', (entry.nomeMidia && entry.nomeMidia.trim()) || entry.file.name)
            dados.append('mimeType', entry.file.type || '')
            dados.append('file', entry.file, entry.file.name)

            await axios.post(
              baseApiUrl + 'Uploads/upload?access_token=' + sessionStorage.getItem('accToken'),
              dados,
              {
                onUploadProgress: (pe) => {
                  if (pe.total) {
                    atualizarProgresso(pe.loaded, pe.total)
                  }
                },
              },
            )
            uidsEnviados.push(entry.uid)
            ok++
          } catch (error) {
            falhas++
            const errorMessage = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
              error.message ||
              'Erro no upload'
            falhouDetalhes.push(`${entry.file.name}: ${errorMessage}`)
          }
        }

        this.uploadProgresso = 100
        this.uploadando = false

        if (ok > 0) {
          vm.carregaMidias(empresaId)
        }

        if (falhas === 0 && ok > 0) {
          vm.$refs.chamaSnackbar.snack(
            'green',
            ok === 1 ? 'Mídia enviada com sucesso!' : `${ok} mídias enviadas com sucesso!`,
            'SUCESSO',
          )
          vm.fecharDialogoUpload()
        } else if (ok > 0 && falhas > 0) {
          const det = falhouDetalhes.join(' • ')
          const extra = det ? ` ${det.length > 160 ? det.slice(0, 157) + '…' : det}` : ''
          vm.$refs.chamaSnackbar.snack(
            'orange',
            `${ok} enviada(s), ${falhas} com erro.${extra}`,
            'ATENÇÃO',
          )
          const okSet = new Set(uidsEnviados)
          this.filaUpload = this.filaUpload.filter((e) => {
            if (okSet.has(e.uid)) {
              if (e.previewUrl) URL.revokeObjectURL(e.previewUrl)
              return false
            }
            return true
          })
        } else if (ok === 0) {
          const det = falhouDetalhes.join(' • ')
          vm.$refs.chamaSnackbar.snack(
            '#EF5350',
            det.length > 280 ? det.slice(0, 277) + '…' : (det || 'Nenhum arquivo foi enviado. Verifique os arquivos e tente novamente.'),
            'DESCULPE',
          )
        }
      },

      fileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => {
            resolve(reader.result)
          }
          reader.onerror = error => reject(error)
        })
      },

      fecharDialogoUpload() {
        if (this.uploadando) return
        this.revogarPreviewsFila()
        this.filaUpload = []
        this.dialogoUpload = false
        this.isDragging = false
        this.uploadProgresso = 0
        this.uploadArquivoAtual = 0
        this.uploadArquivoTotal = 0
      },

      deleteItem(item) {
        this.midiaParaExcluir = item
        this.dialogoExcluir = true
      },

      fecharDialogoExcluir() {
        if (this.excluindo) return
        this.dialogoExcluir = false
      },

      async confirmarExclusao() {
        const item = this.midiaParaExcluir
        if (!item || !item.id) return

        const vm = this
        const empresaId = this.user.tipo == 'ADMIN' || (this.user.tipo == 'GERENTE' && this.user.franquia)
          ? this.empresaSelecionada
          : this.companyobj.id

        this.excluindo = true
        try {
          await axios.post(baseApiUrl + 'Uploads/deletar?access_token=' + sessionStorage.getItem('accToken'), {
            uploadId: item.id,
          })
          vm.$refs.chamaSnackbar.snack('green', 'Mídia excluída com sucesso!', 'SUCESSO')
          this.dialogoExcluir = false
          this.midiaParaExcluir = null
          this.carregaMidias(empresaId)
        } catch (error) {
          const errorMessage = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) ||
            'Problema ao excluir mídia, tente novamente'
          vm.$refs.chamaSnackbar.snack('#EF5350', errorMessage, 'DESCULPE')
        } finally {
          this.excluindo = false
        }
      },


      formatarTamanhoKb(item) {
        if (!item || item.tamanho == null || item.tamanho === '') return '-'
        const n = typeof item.tamanho === 'number' ? item.tamanho.toFixed(2) : item.tamanho
        return n + ' KB'
      },

      transformaData(data, formato) {
        return moment(data).format(formato)
      },

      getTipoColor(tipo) {
        switch(tipo) {
          case 'IMAGEM':
            return '#2196F3'
          case 'VÍDEO':
            return '#F44336'
          case 'PDF':
            return '#FF9800'
          case 'OUTRO':
            return '#757575'
          default:
            return '#757575'
        }
      },

      openMedia(item) {
        if (!item.url) {
          this.$refs.chamaSnackbar.snack("orange", "URL da mídia não disponível", "ATENÇÃO")
          return
        }

        if (item.tipo === 'OUTRO') {
          this.abrirEmNovaAba(item)
          return
        }

        this.midiaVisualizada = item
        this.dialogoVisualizar = true
      },

      fecharDialogoVisualizar() {
        this.dialogoVisualizar = false
      },

      abrirEmNovaAba(item) {
        if (!item || !item.url) return
        window.open(item.url, '_blank')
      },

      handlePreviewError() {
        this.$refs.chamaSnackbar.snack("orange", "Não foi possível carregar a visualização da mídia", "ATENÇÃO")
      },

      handleImageError(e) {
        e.target.style.display = 'none'
      },

      truncateName(name) {
        if (!name) return ''
        if (name.length > 20) {
          return name.substring(0, 17) + '...'
        }
        return name
      },

      getMediaUrl(url) {
        return url || ''
      },

      midiaAcabouDeCopiar(item) {
        if (this.midiaCopiadaId === null || this.midiaCopiadaId === undefined) return false
        return String(this.midiaCopiadaId) === String(item.id)
      },

      copiarTextoFallback(texto) {
        const ta = document.createElement('textarea')
        ta.value = texto
        ta.setAttribute('readonly', '')
        ta.style.position = 'fixed'
        ta.style.left = '-9999px'
        ta.style.top = '0'
        document.body.appendChild(ta)
        ta.focus()
        ta.select()
        ta.setSelectionRange(0, texto.length)
        try {
          const ok = document.execCommand('copy')
          if (!ok) {
            throw new Error('execCommand copy falhou')
          }
        } finally {
          document.body.removeChild(ta)
        }
      },

      mostrarSnackbarCopiar(mensagem, cor) {
        this.snackbarCopiarMsg = mensagem
        this.snackbarCopiarCor = cor
        this.snackbarCopiar = true
      },

      async copiarTexto(texto, midiaId) {
        if (!texto) {
          this.mostrarSnackbarCopiar('URL da mídia não disponível.', 'warning')
          return
        }

        let copiou = false

        try {
          if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(texto)
            copiou = true
          }
        } catch (e) {
          copiou = false
        }

        if (!copiou) {
          try {
            this.copiarTextoFallback(texto)
            copiou = true
          } catch (e) {
            copiou = false
          }
        }

        if (copiou) {
          if (midiaId !== undefined && midiaId !== null && midiaId !== '') {
            this.midiaCopiadaId = midiaId
            const idMarcado = midiaId
            setTimeout(() => {
              if (String(this.midiaCopiadaId) === String(idMarcado)) {
                this.midiaCopiadaId = null
              }
            }, 3000)
          }
          this.mostrarSnackbarCopiar('URL copiada para a área de transferência.', 'success')
        } else {
          this.mostrarSnackbarCopiar('Não foi possível copiar. Use HTTPS ou copie a URL manualmente.', 'warning')
        }
      },
    },
  }
</script>

<style scoped>
  .midias-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 20px;
  }

  .midias-toolbar-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
  }

  .midias-toolbar-busca {
    max-width: 300px;
    flex: 1 1 200px;
  }

  .midias-toolbar-filtro-tipo {
    max-width: 190px;
    flex: 0 0 auto;
    margin-top: 0;
    padding-top: 0;
  }

  .upload-queue-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    margin-bottom: 10px;
    background: #f5f5f5;
    border-radius: 8px;
  }

  .upload-queue-thumb {
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;
    background: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-queue-thumb img,
  .upload-queue-thumb video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .upload-queue-fields {
    flex: 1;
    min-width: 0;
  }

  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;
    padding: 10px 0;
  }

  .media-card {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
  }

  .media-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }

  .media-thumbnail {
    width: 100%;
    min-height: 240px;
    height: 240px;
    background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .thumbnail-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
  }

  .thumbnail-image img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }

  .thumbnail-video {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .thumbnail-video video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }

  .play-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0,0,0,0.5);
    border-radius: 50%;
    padding: 10px;
  }

  .thumbnail-pdf {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%);
  }

  .thumbnail-other {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .media-card:hover .overlay {
    opacity: 1;
  }

  .media-info {
    padding: 12px;
  }

  .media-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .media-meta {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #666;
  }

  .media-size {
    font-size: 11px;
    color: #999;
  }

  .card-action-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255,255,255,0.9) !important;
    z-index: 10;
  }

  .empty-state {
    text-align: center;
    padding: 80px 20px;
    grid-column: 1 / -1;
  }

  .upload-area {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 60px 40px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fafafa;
  }

  .upload-area:hover,
  .upload-area.drag-over {
    border-color: #2C2E83;
    background: #f0f4ff;
  }

  .upload-content {
    pointer-events: none;
  }

  .preview-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid #e0e0e0;
  }

  .preview-modal-title {
    font-size: 18px;
    font-weight: 600;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .preview-modal-body {
    padding: 0 !important;
    background: #1a1a1a;
  }

  .preview-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    max-height: 70vh;
    padding: 16px;
  }

  .preview-image {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    display: block;
  }

  .preview-video {
    max-width: 100%;
    max-height: 70vh;
    width: 100%;
    outline: none;
  }

  .preview-pdf {
    padding: 0;
    height: 70vh;
  }

  .preview-iframe {
    width: 100%;
    height: 70vh;
    border: none;
    background: #fff;
  }

  .preview-other {
    flex-direction: column;
    background: #fafafa;
    min-height: 240px;
  }

  .preview-modal-actions {
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
  }
</style>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  /* Acima dos v-dialog (preview / exclusão / upload) */
  .midias-snackbar-copy {
    z-index: 10001 !important;
  }
</style>

